import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kalyaninagartomumbaitaxi() {



const cardData = {
  keyword: " Kalyani Nagar to Mumbai Taxi  ",

"headingDescription": "SRS Cab Service offers Kalyani Nagar to Mumbai Taxi, providing a comfortable, reliable, and safe travel solution for business travelers, corporate clients, and leisure passengers. Our well-maintained vehicles, professional drivers, and timely pickups ensure a smooth journey from Kalyani Nagar to Mumbai. Ideal for airport transfers, corporate trips, and personal travel, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free ride.",
"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Gateway of India is one of Mumbai’s most iconic landmarks overlooking the Arabian Sea. Travelers using Kalyani Nagar to Mumbai Taxi from SRS Cab Service often visit this historic site for sightseeing and photography."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive is a famous seaside promenade known for its stunning sunset views. Visitors using SRS Cab Service often enjoy relaxing walks along this scenic coastline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves are UNESCO-listed rock-cut caves located on an island near Mumbai. Travelers using SRS Cab Service often include this destination for historical and cultural exploration."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "This historic railway station features Victorian Gothic architecture. Visitors using SRS Cab Service often admire its grandeur and heritage significance."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is a popular destination in Mumbai known for its lively atmosphere and street food. Travelers using SRS Cab Service often visit to enjoy sunset views and local cuisine."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple is a renowned temple dedicated to Lord Ganesha. Visitors using SRS Cab Service often seek blessings and spiritual peace."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah is a revered mosque located on an islet in the Arabian Sea. Travelers using SRS Cab Service often visit for spiritual significance and scenic beauty."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is a bustling shopping and cultural street in Mumbai. Travelers using SRS Cab Service often explore this area for shopping, dining, and local experiences."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a vast green space offering wildlife, trekking, and nature activities. Visitors using SRS Cab Service often enjoy outdoor adventures here."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "Bandra-Worli Sea Link is an iconic bridge connecting key areas of Mumbai. Travelers using SRS Cab Service often take this route for scenic views and a smooth drive."
  }
],



services: [
{
name: "Kalyani Nagar to Mumbai Taxi Fare",
description: "Kalyani Nagar to Mumbai taxi fare provides estimated pricing for intercity travel. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe expressway journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Kalyani Nagar to Mumbai Airport Cab",
description: "Kalyani Nagar to Mumbai airport cab offers reliable transfer for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Kalyani Nagar to Dadar Cab",
description: "Kalyani Nagar to Dadar cab provides convenient travel for central Mumbai routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Kalyani Nagar to Mumbai International Airport Cab",
description: "Kalyani Nagar to Mumbai international airport cab provides premium airport transfer services. Customers can book cabs for smooth journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Kalyani Nagar to Mumbai One Day Cab",
description: "Kalyani Nagar to Mumbai one day cab offers quick round trip travel for business visits. Customers can book cabs for same-day return journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with one day cab services."
},
{
name: "Kalyani Nagar to Mumbai Airport Drop Cab",
description: "Kalyani Nagar to Mumbai airport drop cab offers direct transportation for timely airport travel. Customers can book cabs for quick drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport drop services."
},
{
name: "Kalyani Nagar to Mumbai Drop Cab",
description: "Kalyani Nagar to Mumbai drop cab provides one-way travel without return charges. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with drop cab services."
},
{
name: "Taxi Service in Kalyani Nagar Pune",
description: "Taxi service in Kalyani Nagar Pune offers reliable transportation for local and outstation travel. Customers can book taxis for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Service in Kalyani Nagar",
description: "Cab service in Kalyani Nagar provides dependable travel for city and intercity routes. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai airport cab offers reliable transfer services for passengers. Customers can book cabs for timely airport drop. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab offers comfortable 7 seater travel for families. Customers can book vehicles for long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Ertiga cab services."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab provides spacious and comfortable SUV travel. Customers can enjoy premium seating and luggage space. Professional drivers ensure safe journeys. Ideal for family and corporate travel. Transparent pricing ensures value. Travel easily with Innova cab services."
},
{
name: "Kalyani Nagar to Mumbai Airport Cabs",
description: "Kalyani Nagar to Mumbai airport cabs provide convenient transfer services for passengers. Customers can book cabs for timely drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Wadgaon Sheri to Mumbai Cabs",
description: "Wadgaon Sheri to Mumbai cabs offer reliable intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Car Rental Service in Kalyani Nagar",
description: "Car rental service in Kalyani Nagar provides flexible vehicle options for travel. Customers can rent cars for business and personal use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with car rental services."
},
{
name: "Cab Service in Yerwada",
description: "Cab service in Yerwada offers reliable transportation for local and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Mumbai SRS Cab Service",
description: "Pune Mumbai SRS cab service provides dependable intercity travel for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for city and outstation travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab offers dependable intercity transportation for customers. Users can book cabs for business and personal trips. Professional drivers ensure safe expressway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cab Service Kalyani Nagar Pune",
description: "Cab service Kalyani Nagar Pune provides reliable travel solutions for local and outstation trips. Customers can book cabs for daily and business use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Kalyani Nagar Pune",
description: "Taxi service Kalyani Nagar Pune offers convenient travel for city and airport routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Kalyani Nagar to Mumbai Taxi Fare","Kalyani Nagar to Mumbai Airport Cab"],
["Kalyani Nagar to Dadar Cab","Kalyani Nagar to Mumbai International Airport Cab"],
["Kalyani Nagar to Mumbai One Day Cab","Kalyani Nagar to Mumbai Airport Drop Cab"],
["Kalyani Nagar to Mumbai Drop Cab","Taxi Service in Kalyani Nagar Pune"],
["Cab Service in Kalyani Nagar","Pune to Mumbai Airport Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Kalyani Nagar to Mumbai Airport Cabs","Wadgaon Sheri to Mumbai Cabs"],
["Car Rental Service in Kalyani Nagar","Cab Service in Yerwada"],
["Pune Mumbai SRS Cab Service","Cab Service in Pune"],
["Pune Mumbai Cab","Cab Service Kalyani Nagar Pune"],
["Taxi Service Kalyani Nagar Pune","Kalyani Nagar to Mumbai Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Quick Pickup from Kalyani Nagar Area",
    WhyChoosedescription: "SRS Cab Service provides fast pickup from Kalyani Nagar, Koregaon Park, Yerwada, and nearby areas for smooth travel to Mumbai."
  },
  {
    WhyChooseheading: "Affordable Kalyani Nagar to Mumbai Taxi Pricing",
    WhyChoosedescription: "We offer budget-friendly taxi services from Kalyani Nagar to Mumbai with transparent pricing. Customers receive full fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are well-experienced on the Mumbai-Pune Expressway, ensuring safe, fast, and comfortable travel."
  },
  {
    WhyChooseheading: "24/7 Taxi Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Kalyani Nagar to Mumbai taxi bookings, ideal for airport transfers, business trips, and emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles ensuring a smooth and relaxing journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way taxi service, round-trip bookings, and same-day return options based on your travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and groups."
  },
  {
    WhyChooseheading: "Trusted Taxi Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted for Kalyani Nagar to Mumbai taxi bookings due to punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Kalyani Nagar to Mumbai taxi service?", answer: "Yes, SRS Cab Service offers reliable taxi services from Kalyani Nagar to Mumbai." },
  { question: "How far is Mumbai from Kalyani Nagar?", answer: "The distance is approximately 150 km and takes around 3 to 4 hours via expressway." },
  { question: "What is the starting taxi fare?", answer: "Taxi fares typically start from ₹1800–₹2600 for sedan depending on availability and timing." },
  { question: "Is one-way taxi available?", answer: "Yes, one-way taxi services are available and are more affordable than round-trip bookings." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7." },
  { question: "Which vehicles are available?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Do you provide Mumbai Airport drop?", answer: "Yes, we provide drop service to Mumbai Airport including T1 and T2 terminals." },
  { question: "Can I book taxi online?", answer: "Yes, you can easily book Kalyani Nagar to Mumbai taxi online or via phone." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, hotels, and offices in Kalyani Nagar." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sharma",
    feedback:
      "Booked taxi from Kalyani Nagar to Mumbai Airport. On-time pickup and smooth journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best taxi service from Kalyani Nagar to Mumbai. Clean car and professional driver.",
    rating: 5
  }
];

























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Kalyani Nagar to Mumbai Taxi Service | SRS Cab Service",
  "description": "Book reliable Kalyani Nagar to Mumbai cabs for airport transfers, one-way or round trips. Innova, Ertiga, and Sedan cabs available with 24x7 online booking.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Kalyani Nagar",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411006",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5450",
    "longitude": "73.9143"
  },
  "url": "https://www.srscabservice.com/kalyani-nagar-to-mumbai-cab",
  "areaServed": ["Kalyani Nagar", "Wadgaon Sheri", "Yerwada", "Mumbai", "Mumbai Airport", "Dadar"],
  "openingHours": "Mo-Su 00:00-23:59",
  "priceRange": "₹₹",
  "serviceType": [
    "Kalyani Nagar to Mumbai Cab",
    "Kalyani Nagar to Mumbai Airport Cab",
    "Kalyani Nagar to Dadar Cab",
    "One-way and round-trip cabs",
    "Innova, Ertiga, Sedan"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "780"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Kalyani Nagar to Mumbai Taxi Service | SRS Cab Service</title>
  <meta 
    name="description" 
    content="Book Kalyani Nagar to Mumbai cabs with SRS Cab Service. One-way, round trip, and airport transfers. Innova, Ertiga, and Sedan cabs available 24x7 online."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kalyaninagartomumbaitaxi;